// Vuex module for network connectivity probing
// All API calls should go through Vuex modules per project guidelines.

import axios from 'axios'

/**
 * Network module
 * Provides actions to check internet connectivity by pinging a lightweight external endpoint.
 * Uses global window.connectivityProbe defined in Services/GlobalVariables.js
 */
export default {
  namespaced: true,
  actions: {
    /**
     * Ping the configured connectivity probe URL to determine if the app is online.
     * Adds a cache-busting query param and no-store header to avoid SW/browser caches.
     *
     * @returns {Promise<boolean>} resolves true if the probe responds, otherwise throws.
     */
    async ping() {
      const base = window.connectivityProbe
      if (!base || typeof base !== 'string') {
        throw new Error('Connectivity probe URL is not configured (window.connectivityProbe)')
      }
      const url = base.includes('?') ? `${base}&_=${Date.now()}` : `${base}?_=${Date.now()}`
      await axios.get(base)
      return true
    },
  },
}
